import type { FaireProductEntity } from "../../entity_types/product";

export const p_h884qzykcx: FaireProductEntity = {
  token: "p_h884qzykcx",
  type: "product",
  name: "Tamanohada - Welcome Gift Soap",
  brandToken: "b_ya4nltd3",
  brandName: "Ameico",
  imageUrl:
    "https://cdn.faire.com/fastly/887559649889b3ec56c62ab0318636310b1365e458b28c693712a170764889b4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2945ef8ea7d0401ed2add0a176b698d2afcc10b88956d882bc687f7cc7d48b50.jpeg",
    "https://cdn.faire.com/fastly/218759ec538181bd252ad84f7e8d4b76ca3a1b484f57cb8560bb7f6612b304fe.jpeg",
    "https://cdn.faire.com/fastly/7dd0be621ce088738b86c10cb0e6759235fa36fafdc7230422162f30a30a99fc.jpeg",
    "https://cdn.faire.com/fastly/34c8305e7b689dcd0ed85e8aa2c3014853b5a6e58742b9af502907546ac48fd2.jpeg",
    "https://cdn.faire.com/fastly/374c322481a27577abd685ffd751e3cdeb76db8547831c80e47a16c9d428fb07.jpeg",
  ],
  priceDollars: 22.5,
  description:
    'Opening Order: 2x scents, sets of 4x each, totaling 8x soaps. \n\nThis soap comes in the form of the Japanese celebratory fish, the bream! This beautiful, delicate shape was created using a process based on the wooden mold used to make the Japanese sweet called Rakugan. Tamanohada soaps are made from entirely plant-based material, from natural plant oil. This soap series is made to give your skin an extra gentle care, and thus could be used for washing your body and also your face. Its texture is between liquid and milk, leaving a delicate moisturize protection and scent to your skin. Leaving your soap on a small dish will also lightly perfume your bathroom. A beautifully gift boxed "soap on a rope" from Tamanohada Soap Co.',
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:29.992Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
